import { LUDUM_SPORTS } from '@/constants';
import { TIME_FORMAT_LONG, TIME_FORMAT_IN_MINUTES_LONG } from '@/constants/dateTimeFormats';
import get from 'get-object-path';

export const SECONDS_IN_HOUR = 3600;

export const SESSION_RESULTS_GRAPH_COLORS = [
    '#008DD5',
    '#00C98E',
    '#F99272',
    '#9C75D4',
    '#C23969',
    '#F3A712',
    '#E74545',
    '#6FBDEC',
    '#28E8B0',
    '#FBBCA8',
    '#C2A9E6',
    '#F89EB4',
    '#E78614',
    '#F98585',
    '#00679B',
    '#2B908F',
    '#F36614',
    '#6D3BB4',
    '#B22E7D',
    '#AD3A02',
    '#F45B5B',
    '#04467D',
    '#03685A',
    '#D43503',
    '#532793',
    '#8D125B',
    '#F3D69D',
    '#B53048',
    '#7F7F7F',
    '#BABABA',
    '#64646C',
    '#2F2F32'
];

export function sessionHasResults(session) {
    return !!get(session, 'statistics.data.has_results');
}

export function sessionHasHrData(session) {
    return !!get(session, 'statistics.data.has_hr_data');
}

export function sessionHasGpsData(session) {
    return !!get(session, 'statistics.data.has_gps_data');
}

export function formatTime(time) {
    const timeFormat = time >= SECONDS_IN_HOUR ? TIME_FORMAT_LONG : TIME_FORMAT_IN_MINUTES_LONG;
    return time ? moment().startOf('day').add(time, 's').format(timeFormat) : '';
}

export function calculateResultsTotalTonnage(userResults) {
    let sportResults = _.filter(userResults, { sport: { id: LUDUM_SPORTS.SC } });
    let exercises = [];
    let totalTonnage = 0;

    _.each(sportResults, result => {
        if (result.pieces) {
            exercises.push(...result.pieces.data);
        }
    });

    _.each(exercises, exercise => {
        _.each(get(exercise, 'segments.data'), segment => {
            totalTonnage += segment.reps_count * segment.exercise_weight;
        });
    });

    return totalTonnage;
}

export function speedLimit(sportId) {
    /*
     Returns the limit for GPS speed results depending on sport. We're limiting/filtering the results because
     some of them have false, too large values.
     */
    switch (sportId) {
        case LUDUM_SPORTS.BIKE:
            return 30;
        default:
            return 10;
    }
}

export function isAthleteSelected(selectedAthletes, athleteId) {
    const isEmpty = selectedAthletes.length === 0;
    const isIn = selectedAthletes.includes(athleteId);
    return isEmpty || isIn;
}

export function isCrewSelected(selectedCrews, id, field = 'id') {
    const isEmpty = selectedCrews.length === 0;
    const crewInFilter = _.find(selectedCrews, crew => crew[field] === id);
    return isEmpty || !!crewInFilter;
}

export function assignResultsToUser(user) {
    // Transform athlete object so it matches 'sport_user_results' format
    if (!user.overall_results && get(user, 'sport.data[0].overall_results')) {
        _.assign(user, { overall_results: user.sport.data[0].overall_results });
    }

    if (!user.pieces && get(user, 'sport.data[0].pieces')) {
        _.assign(user, { pieces: user.sport.data[0].pieces });
    }
}